<div class="maintenance-page">
  <header class="page-header">
    <app-back-button title="adminMaintenance.title" parentRoute="/admin"></app-back-button>
    <p>AdminMaintenance API</p>
  </header>

  <div class="commands-grid">
    @for (command of commands; track command.id) {
      <section class="command-card">
        <div class="command-heading">
          <div>
            <h3>{{ command.title | translate }}</h3>
            <code>{{ command.endpoint }}</code>
          </div>
          <span class="method-badge">POST</span>
        </div>

        <p class="description">{{ command.description | translate }}</p>

        <div class="command-controls">
          <label [for]="command.id + '-batch-size'">
            {{ 'adminMaintenance.batchSize' | translate }}
            <span>1–5000</span>
          </label>
          <input
            [id]="command.id + '-batch-size'"
            type="number"
            min="1"
            max="5000"
            step="1"
            [(ngModel)]="command.batchSize"
            [disabled]="command.running"
          />
          <button
            pButton
            type="button"
            icon="pi pi-play"
            [label]="'adminMaintenance.run' | translate"
            [loading]="command.running"
            [disabled]="command.running || command.batchSize < 1 || command.batchSize > 5000"
            (click)="run(command)"
          ></button>
        </div>

        @if (command.result) {
          <div class="result result-success">
            <div class="result-title">
              <i class="pi pi-check-circle"></i>
              {{ 'Result' | translate }}
            </div>
            <div class="result-stats">
              <span>{{ 'adminMaintenance.examined' | translate }} <strong>{{ command.result.examined ?? 0 }}</strong></span>
              <span>{{ 'adminMaintenance.hidden' | translate }} <strong>{{ command.result.hidden ?? 0 }}</strong></span>
              <span>{{ 'adminMaintenance.insideCountry' | translate }} <strong>{{ command.result.insideCountry ?? 0 }}</strong></span>
              <span>{{ 'adminMaintenance.withoutGeometry' | translate }} <strong>{{ command.result.skippedNoGeometry ?? 0 }}</strong></span>
              <span>{{ 'adminMaintenance.invalidGeometry' | translate }} <strong>{{ command.result.skippedInvalidGeometry ?? 0 }}</strong></span>
            </div>
            <pre>{{ formattedResult(command.result) }}</pre>
          </div>
        }

        @if (command.error) {
          <div class="result result-error">
            <div class="result-title">
              <i class="pi pi-times-circle"></i>
              {{ 'Failed' | translate }}
            </div>
            <pre>{{ command.error }}</pre>
          </div>
        }
      </section>
    }
  </div>
</div>
